import { gql } from "@/__generated__/gql";

export const UPDATE_PROFILE_MUTATION = gql(`
  mutation UpdateProfile(
    $userId: ID!
    $firstName: String!
    $lastName: String!
    $bio: String
    $locationCityId: ID
    $interestIds: [ID!]
    $majorIds: [ID!]
    $profilePhoto: Upload
  ) {
    updateUserProfileMutation(input: {
      userId: $userId
      firstName: $firstName
      lastName: $lastName
      bio: $bio
      locationCityId: $locationCityId
      interestIds: $interestIds
      majorIds: $majorIds
      profilePhoto: $profilePhoto
    }) {
      clientMutationId
      errors {
        title
        message
      }
    }
  }
`);
